/*
 * Hiza — size guide modal
 *
 * Progressive enhancement, deliberately in that order:
 *
 *   No JS  → the guide renders inline in the page and the buy-box link is a
 *            plain anchor that scrolls to it. Fully usable.
 *   With JS → the same panel is MOVED into a <dialog> and the link opens it,
 *            so the shopper never loses their place on the product page.
 *
 * The content is never generated here, only relocated — so it is always in
 * the DOM for crawlers and for anyone the script fails for.
 *
 * <dialog>.showModal() is doing the heavy lifting: focus trap, Esc to close,
 * inert background and focus restore are all native. Baseline since 2022.
 */
(function () {
  'use strict';

  var DIALOG_ID = 'HizaSizeGuideDialog';

  function init() {
    var panel = document.getElementById('hiza-size-guide');
    var triggers = document.querySelectorAll('.hz-guide-trigger__link');

    if (!panel || !triggers.length) return;
    if (document.getElementById(DIALOG_ID)) return; // already upgraded
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) {
      return; // no <dialog> support: leave the anchor fallback alone
    }

    var dialog = document.createElement('dialog');
    dialog.id = DIALOG_ID;
    dialog.className = 'hz-guide-dialog';
    dialog.setAttribute('aria-label', 'Size guide');

    var shell = document.createElement('div');
    shell.className = 'hz-guide-dialog__shell';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'hz-guide-dialog__close';
    close.setAttribute('aria-label', 'Close size guide');
    close.innerHTML =
      '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false" ' +
      'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">' +
      '<path d="M4 4l12 12M16 4L4 16"/></svg>';

    // Move, not clone — one copy of the content, no duplicate ids in the DOM.
    panel.parentNode.removeChild(panel);
    panel.classList.add('hz-guide--in-dialog');

    shell.appendChild(close);
    shell.appendChild(panel);
    dialog.appendChild(shell);
    document.body.appendChild(dialog);

    var lastTrigger = null;

    function open(event) {
      event.preventDefault();
      lastTrigger = event.currentTarget;
      dialog.showModal();
    }

    Array.prototype.forEach.call(triggers, function (t) {
      t.addEventListener('click', open);
    });

    close.addEventListener('click', function () {
      dialog.close();
    });

    // Click the backdrop to dismiss. The dialog element's own box covers the
    // whole viewport, so compare against the shell's rectangle rather than
    // relying on event.target, which reports the dialog for backdrop clicks.
    dialog.addEventListener('click', function (event) {
      var box = shell.getBoundingClientRect();
      var outside =
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom;
      if (outside) dialog.close();
    });

    dialog.addEventListener('close', function () {
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn re-renders sections in the theme editor; re-upgrade when it does.
  document.addEventListener('shopify:section:load', function () {
    var existing = document.getElementById(DIALOG_ID);
    if (existing) existing.remove();
    init();
  });
})();
